import * as React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

type LabelWithDescriptionProps = {
  label: string;
  description: string;
};

const LabelWithDescription = (props: LabelWithDescriptionProps) => {
  return (
    <div>
      {props.label}
      <Tippy content={props.description} placement="right" theme="navyblue">
        <i className="fa-solid fa-circle-question ml-1 hover:text-ev-baby-blue-2" />
      </Tippy>
    </div>
  );
};

export default LabelWithDescription;
